import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "@mui/material"

import BlogForm from "./BlogForm"
import { getBlogs, saveBlogs } from "../../Utils/blogStorage"
import Navbar from "../CommonC/SelexSolNavbar";
import { baseURL } from "../../Config/config";


function AdminAddBlog(){

const navigate = useNavigate()

const [blog,setBlog] = useState({
title:"",
slug:"",
description:"",
author:"",
image:"",
content:"",
status: "pending"

})


const submit = async () => {

  const blogToSubmit = {
    ...blog,
    status: "pending"
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(blogToSubmit),
  };

  try {
    let res = await fetch(`${baseURL}/addblog`, requestOptions);
    res = await res.json();

    if (res.code) {
      alert("Blog submitted for review successfully.");
      navigate("/adminhome");
      return;
    }

    alert("Some Error");
  } catch (error) {
    alert("Some Error");
    console.log("err", error);
  }
};
return(

    <div
        style={{
          height:window.screen.height
        }}
      >
       
        <Navbar admin={true}/>

<Container sx={{background:"white", maxHeight: "750px",overflowY: "auto",marginTop:"15px",padding:"10px"}}>

<BlogForm
blog={blog}
setBlog={setBlog}
onSubmit={submit}
/>

</Container>
</div>

)

}

export default AdminAddBlog